export const LIFF_ID = process.env.REACT_APP_LIFF_ID as string;

export const LIFF_ENDPOINT = process.env.REACT_APP_LIFF_ENDPOINT as string;

export const LIFF_URL = process.env.REACT_APP_LIFF_URL as string;

export const SMARTRECEIPT_LINK = process.env
  .REACT_APP_SMARTRECEIPT_LINK as string;

export const PRODUCT_RESERVATION_LINK = process.env
  .REACT_APP_PRODUCT_RESERVATION_LINK as string;

export const GA_TRACKING_ID = process.env.REACT_APP_GTM_ID;

export const BASE_URL = process.env.REACT_APP_API_ENDPOINT;
export const API_SUCCEEDED = 'succeeded';
export const API_FAILED = 'failed';

export const EBASE_APP_URL =
  'https://enavi-espot.ebase-jp.com/eshokujyudx/DispAppMenu.do';

/**
 * セッション切れ画面のパス
 */
export const SESSION_EXPIRED_PAGE_PATH = '/session-expired';

/**
 * 外部のクレジットカードチャージサイトへの移動画面のパス
 */
export const ONLINE_CHARGE_TRANSITION_PAGE_PATH = '/online-charge';

/**
 * 外部のクレジットカードチャージサイトへの移動画面のURL
 */
export const ONLINE_CHARGE_TRANSITION_PAGE_URL = `${LIFF_ENDPOINT}${ONLINE_CHARGE_TRANSITION_PAGE_PATH}`;

/**
 * 外部のクレジットカードチャージサイトのURL
 * 開発環境は存在しない（本番環境）
 * https://www.notion.so/digiclue/1Q-b9deee1b4b784a1081190441e131e658?pvs=4#819c1034ea1a434d87a9cf5439c33b32
 */
export const ONLINE_CHARGE_URL = 'https://makiya.onlinecharge.jp';

/**
 * 外部のクレジットカードチャージサイトにログインする際に利用するカード番号の先頭につける番号
 * https://www.notion.so/digiclue/1Q-b9deee1b4b784a1081190441e131e658?pvs=4#fe1c7f718bf74b7a9120fa793521287f
 */
export const ONLINE_CHARGE_CARD_NO_PREFIX = 881;

/**
 * 表示する広告ポップアップの外部スクリプトURL
 */
export const POPUP_AD_SRC =
  'https://gcmadv-cdn.goldspotmedia.com/delivery/ad/46bf675b-99a8-4e58-8405-9886d84cc35d?gi=gcmInfo_46bf675b99a84e5884059886d84cc35d';
export const POPUP_GCM_SRC =
  'https://gcmast-cdn.goldspotmedia.com/libs/gcm-player/1.10.1/gcm-player.min.js?tg=gcmInfo_46bf675b99a84e5884059886d84cc35d&tm=gcmMediaInfo_46bf675b99a84e5884059886d84cc35d';
export const POPUP_GCM_INFO = 'gcmMediaInfo_46bf675b99a84e5884059886d84cc35d';

/**
 * 入力文字数上限（SJISバイト換算 / countByte準拠）
 * CSD（東芝テック CS-Delight）の受入上限に合わせている
 * https://www.notion.so/3376f15ab9f680cc9427ecd673a121da
 */
// 氏名（漢字）姓+名: CSD顧客名称（漢字）48byte − 全角スペース区切り2byte = 46byte（全角23文字）
export const FULL_NAME_MAX_BYTE = 46;
// フリガナ（カナ）姓+名: CSD顧客名称（カナ）24byte − 半角スペース区切り1byte = 23byte（半角変換後）
export const FULL_NAME_KANA_MAX_BYTE = 23;
// 住所１・住所２
export const ADDRESS_MAX_BYTE = 40;

/**
 * 表示する広告バナーの変数
 */
export const AD_BANNERS = [
  {
    fluctGroupId: '1000175749',
    fluctUnitName: 'fluct-unit-1000279899-1',
    fluctUnitId: '1000279899'
  },
  {
    fluctGroupId: '1000175750',
    fluctUnitName: 'fluct-unit-1000279900-1',
    fluctUnitId: '1000279900'
  },
  {
    fluctGroupId: '1000175751',
    fluctUnitName: 'fluct-unit-1000279901-1',
    fluctUnitId: '1000279901'
  },
  {
    fluctGroupId: '1000175752',
    fluctUnitName: 'fluct-unit-1000279902-1',
    fluctUnitId: '1000279902'
  },
  {
    fluctGroupId: '1000181798',
    fluctUnitName: 'fluct-unit-1000288480-1',
    fluctUnitId: '1000288480'
  }
];
